import get from 'lodash/get';

class Price {
  /**
   * Initialize a new instance of Price object.
   * @param data
   */
  constructor(data) {
    this.value = get(data, 'value', get(data, 'low.value'));
    this.formatted = get(data, 'formatted', get(data, 'low.formatted'));
  }
}

export {Price};
